import "../../App.css";
import { useEffect } from "react";
import React, { useState, useRef } from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import YouTubePlayer from "../../components/VideoPlayer/videoPlayer";
import "./SuperiorESP.css";
import { useNavigate } from "react-router-dom";

const SupESP = () => {
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef(null);
  const [stage, setStage] = useState(1);

  const navigate = useNavigate();

  const handleComprar = () => {
    navigate("/products/35-Superior%20ESP");
  };

  useEffect(() => {
    const timer1 = setTimeout(() => setStage(2), 2000);
    const timer3 = setTimeout(() => setStage(4), 2000);
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer3);
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);

  return (
    <div>
      <Header />
      <div className="animation-container">
        {stage === 1 && (
          <>
            <img
              src="/images/animación_parte1.png"
              className="image image-1"
              alt="Parte 1"
            />
            <img
              src="/images/animación_parte2.png"
              className="image image-2"
              alt="Parte 2"
            />
          </>
        )}
        {stage >= 3 && (
          <img
            src="/images/animación_parte4.png"
            className="image image-4 fade-in permanent"
            alt="Parte 4"
          />
        )}
      </div>
      <div
        className={`order-now ${isVisible ? "visible" : ""}`}
        ref={containerRef}
      >
        <h1>Superior ESP</h1>
        <h2>El cerebro detrás de tus proyectos más innovadores</h2>
        <button className="order-btn" onClick={handleComprar}>
          {" "}
          Compra ahora
        </button>
      </div>

      {/* Famous animation section */}

      <YouTubePlayer videoUrl="https://youtu.be/e1OWYZ1zAfs" />

      <div className="ESP-info-container">
        <h1 className="ESP-title">
          ¡La placa de microcontrolador más <br />
          divertida y fácil de usar!
        </h1>
        <div className="ESP-content">
          <div className="ESP-image-container">
            <img
              src={"/images/insignia.png"}
              alt="Microcontrolador ESP32"
              className="ESP-image"
            />
            <div className="ESP-dots-overlay"></div>
          </div>
          <div className="ESP-text-container">
            <div className="ESP-text ESP-text-1">
              Numerosos pines digitales y<br />
              de alimentación
            </div>
            <div className="ESP-text ESP-text-2">
              Conexión Wi-Fi y Bluetooth
            </div>
            <div className="ESP-text ESP-text-3">
              Distintas alternativas de <br />
              puertos de conexión
            </div>
            <div className="ESP-text ESP-text-4">
              Programable en Arduino IDE,
              <br />
              Python, JavaScript
            </div>
            <div className="ESP-text ESP-text-5">
              Funcional como ESP32
              <br />
              independiente o potenciado
              <br />
              con placa de expansión
            </div>
          </div>
        </div>
      </div>
      <div className="technical-specs-container">
        <div className="technical-specs-box">
          <div>
            <h2 className="technical-specs-title">
              Especificaciones técnicas:
            </h2>
            <ul className="technical-specs-list">
              <li>25 Pines Digitales</li>
              <li>30 Pines de alimentación</li>
              <li>SRAM: 250 Kb</li>
              <li>Memoria Flash: 4MB</li>
              <li>Bluetooth v5</li>
              <li>Wi-Fi v6</li>
              <li>Alimentación por USB-C, Jack o MicroUSB</li>
            </ul>
          </div>
        </div>
        <img
          src="/images/ESP_Caja.png"
          alt="Descripción de la imagen"
          className="technical-specs-image"
        />
      </div>
      <div className="ESP-info-container">
        <h1 className="ESP-title">
          La mejor opción para proyectos que requieran una placa poderosa con
          mayor potencia y versatilidad
        </h1>
        <div className="image-rotation-container">
          <button className="order-btn" onClick={handleComprar}>
            {" "}
            Compra Ahora
          </button>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default SupESP;
